module.exports = __webpack_public_path__ + "static/media/band-champion.a5988300.svg";